export const imageCodes = {

    mySliderOne: {
        code: "${merchantId}_tmpl_img_1",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FLanding%203.jpg?alt=media&token=cbb20ad9-eef4-4caa-bd3f-cf51e0f6f24b"
    },

    mySliderTwo: {
        code: "${merchantId}_tmpl_img_20",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Flanding%206%20(1).jpg?alt=media&token=2afd901d-e42a-4620-aa93-0e189e43bbfc"
    },

    myFeature1: {
        code: "${merchantId}_tmpl_img_13",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FINF04545%20latest%20(1).jpg?alt=media&token=6f67f84a-8d71-4879-90ee-0cac9f8c97fc"
    },

    myFeature2: {
        code: "${merchantId}_tmpl_img_10",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FINF04545.jpg?alt=media&token=921ddcdb-4d73-4266-9651-d3c566f66800"
    },

    myFeature3: {
        code: "${merchantId}_tmpl_img_15",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FINF04546.jpg?alt=media&token=71cffcc3-54f4-4e4f-a935-4006631d52a2"
    },

    myWhoWeAre: {
        code: "${merchantId}_tmpl_img_16",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Four.jpg?alt=media&token=d31bdfb5-219b-48df-86ee-d1a403c6587d"
        
    },

    myWhoWeAre1: {
        code: "${merchantId}_tmpl_img_21",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Four.jpg?alt=media&token=906f19db-81ed-45b4-9aff-e6990c8eef46"
    },

    myWeDo: {
        code: "${merchantId}_tmpl_img_17",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Four1.jpg?alt=media&token=99a18385-bfaa-4368-b965-d2fa23a770ed"

    },

    myWhoWe: {
        code: "${merchantId}_tmpl_img_10",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FINF04545.jpg?alt=media&token=949e44ba-844f-4366-833c-43602c3e4999"
    },

    myFeaturePhoto1: {
        code: "${merchantId}_tmpl_img_4",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FINF04776.jpg?alt=media&token=0944a596-c050-4591-ae53-93d313ac8fae"
    },

    myFeaturePhoto2: {
        code: "${merchantId}_tmpl_img_3",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FINF04554.jpg?alt=media&token=ef89765b-cb79-4e12-88cd-76f2cfae1f5b"
    },

    myFeaturePhoto3: {
        code: "${merchantId}_tmpl_img_5",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FINF04918.jpg?alt=media&token=718b7d6c-c047-4f3c-95dc-17dc8a8302be"
    },

    myFeaturePhoto4: {
        code: "${merchantId}_tmpl_img_6",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FINF05030.jpg?alt=media&token=7e107ff6-9227-4949-b3a7-f51992d3792b"
    },

    myFeaturePhoto5: {
        code: "${merchantId}_tmpl_img_7",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FINF05091.jpg?alt=media&token=16c528e4-8dd7-449f-b2f8-2f1e3e5daa7f"

    },

    myFeaturePhoto6: {
        code: "${merchantId}_tmpl_img_8",

        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FINF05134.jpg?alt=media&token=d335eb27-d821-40d5-885b-927aea9bfeab"

    },

    myFeaturePhoto7: {
        code: "${merchantId}_tmpl_img_9",

        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fpick.jpg?alt=media&token=c54ca745-c2dc-4272-a7f3-615a95a077cf"
    },

    myTrackOrder: {
        code: "${merchantId}_tmpl_img_18",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FTrack%20your%20order%20(1).jpg?alt=media&token=cfe57adc-b66c-41d0-aded-f0a3407a4560"

        
    },

    myMediaRoom: {
        code: "${merchantId}_tmpl_img_19",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Flanding%206%20(1).jpg?alt=media&token=2afd901d-e42a-4620-aa93-0e189e43bbfc"
    },

}

export const titleCodes = {

    myOurProduct: {
        code: "${merchantId}_tmpl_title_1",
        title: "shop our products",
    },

    myOurStory: {
        code: "${merchantId}_tmpl_title_2",
        title: "our story",
    },

    myWhoTitle: {
        code: "${merchantId}_tmpl_title_3",
        title: "who we are",
    },

    myDoTitle: {
        code: "${merchantId}_tmpl_title_4",
        title: "what we do",
    },

    myFeaturePhotos: {
        code: "${merchantId}_tmpl_title_5",
        title: "featured photos",
    },

    myTrackYourOrder: {
        code: "${merchantId}_tmpl_title_6",
        title: "track your order",
    },

    myMediaRoomTitle: {
        code: "${merchantId}_tmpl_title_7",
        title: "media room",
    },
}

export const textCodes = {

    myStory1: {
        code: "${merchantId}_tmpl_text_1",
        text: "“Minimalism” ကို အခြေပြုဖန်တီးထားတဲ့ Willow Clothing brand ဟာ elegant ဖြစ်ပြီး ရိုးရှင်းစွာ ရှင်သန်ရတဲ့ lifestyle ကို တန်ဖိုးထားပါတယ်။ အဲဒီ့အတွက်ကြောင့် Willow brand မှထွက်ရှိမယ့် အဝတ်အစားများကလဲ Versatile ဖြစ်ပြီး ကိုယ်ပိုင် style အမျိုးမျိုး ပြောင်းလဲကာ ဘယ်နေရာမဆို ဝတ်ဆင်နိုင်ရန် ကျွန်မတို့ founder ၂ ယောက်က ရည်ရွယ်ပြီး ထုတ်လုပ်ထားပါတယ်။"
    },

    myStory3: {
        code: "${merchantId}_tmpl_text_3",
        text: "Willow ရဲ့ ခံယူချက် ကတော့ “quality over quantity” ဖြစ်တဲ့ အတွက် မြန်မာနိုင်ငံရဲ့ ရာသီဥတုနဲ့ လိုက်ဖက်ပြီး အရည်အသွေးမြင့်တဲ့ fabric များကိုသာအသုံးပြုထားပါတယ်။ ဒီဇိုင်းအနေနဲ့ ဆိုရင်လဲ ကြာရှည်ခံပြီး ဘယ်တော့မဆို ရိုးမသွားမယ့် product design များကိုသာ ဖန်တီးပေးနိုင်အောင် အမြဲတမ်းကြိုးစားသွားမှာဖြစ်ပါတယ်။"
    },

    myWedo1: {
        code: "${merchantId}_tmpl_text_4",
        text: "Simplicity & Quality ကို အမြဲတမ်း နံပါတ် ၁ နေရာထားပြီး ထုတ်လုပ်ထား တဲ့ Willow ရဲ့ clothing line လေးကတော့ မေမေ, ဖေဖေ နဲ့ ကလေးငယ်လေးများအတွက် အဓိကရည်ရွယ်ထားပြီး versatile ဖြစ်စေမယ့် matching apparels လေးများစွာကို collection တစ်ခုချင်းစီ ထွက်ရှိမှာ ဖြစ်ပါတယ်။"
    },

    myWedo2: {
        code: "${merchantId}_tmpl_text_5",
        text: "Willow ရဲ့ matching apparels လေးတွေကို တူတူဝတ်ပြီး တန်ဖိုးရှိတဲ့အမှတ်တရလေးတွေကို ဖန်တီရင်း မေမေ ဖေဖေတို့ နဲ့ ကလေးငယ်တွေကြားမှာရှိတဲ့ ရင်းနှီးမှု သံယောဇဉ် bond လေး ပိုမိုခိုင်မာလာစေဖို့ အတွက် Willow Clothing Brand လေးကို ဖန်တီးထားပါတယ်။"
    },

    myWomenText: {
        code: "${merchantId}_tmpl_text_9",
        text: 'Designed for any kind of occassion, whether you are a mother or not.'
    },

    myBoyText: {
        code: "${merchantId}_tmpl_text_7",
        text: 'Smart and fun pieces for your dearest boy.'
    },

    myGirlText: {
        code: "${merchantId}_tmpl_text_8",
        text: 'Elegant pieces to style your little girl.'
    },

    myShopText: {
        code: "${merchantId}_tmpl_title_6",
        text: "shop"
    },

    eng: {
        code: "${merchantId}_tmpl_text_14",
        text: '– English'
    },
}